import LayoutBasic from "@/views/layouts/LayoutBasic";
import NewOrder2 from "@/views/orders/New2";
import EditOrder from "@/views/orders/Edit2";
import listOrders from "@/views/orders/list";
import searchOrder from "@/views/orders/search";
import ordersByDrugs from "@/views/orders/byDrugs";
import OutsorceOrders from "@/views/orders/OutsorceOrders";
import PartnerOrders from "@/views/orders/PartnerOrders";
import PostCloseByFile from "@/views/orders/PostCloseByFile.vue";
import PostTrackNumbers from "@/views/orders/PostTrackNumbers.vue";
import RejectedOrders from "@/views/orders/Rejected.vue";

const routes = {
  path: '/orders',
  component: LayoutBasic,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'new',
      name: 'newOrder',
      component: NewOrder2
    },
    {
      path: 'postcf',
      name: 'PostCloseByFile',
      component: PostCloseByFile
    },
    {
      path: 'partner',
      name: 'PartnerOrders',
      component: PartnerOrders,
      meta: {
        allowedTo: ['partner'],
      }
    },
    {
      path: 'edit/:id',
      name: 'editOrder',
      component: EditOrder
    },
    {
      path: 'list',
      name: 'listOrders',
      component: listOrders
    },
    {
      path: 'listManual',
      name: 'listOrdersManual',
      component: listOrders
    },
    {
      path: 'listDelivery',
      name: 'listOrdersDelivery',
      component: listOrders
    },
    {
      path: 'listpost',
      name: 'listOrdersPost',
      component: listOrders
    },
    {
      path: 'search',
      name: 'searchOrder',
      component: searchOrder
    },
    {
      path: 'searchRefund',
      name: 'searchOrderRefund',
      component: searchOrder
    },
    {
      path: 'byDrugs',
      name: 'ordersByDrugs',
      component: ordersByDrugs
    },
    {
      path: 'outsource',
      name: 'outsourceOrders',
      component: OutsorceOrders
    },
    {
      path: 'posttrack',
      name: 'PostTrackNumbers',
      component: PostTrackNumbers
    },
    {
      path: 'rejected',
      name: 'RejectedOrders',
      component: RejectedOrders,
      meta: {
        accessName: 'orders/rejected'
      }
    },
  ]
}

export default routes;
